<template>
<div>
    <div class='h-text-center h-mb-30'>
        <div class='b-base-title h-mt-10'>
            {{ $t('AUTH.RESET_PASSWORD.TITLE') }}
        </div>
    </div>
    <div>
        <form class='h-mt-15'
              @keyup.enter='sendDataToServer'>
            <FwFormInput
                class='h-mb-25'
                :fieldHasError='fieldHasErrorByRule(password, PASSWORD, passwordRules)'
                labelType='label-thin'
                :title='$t(`AUTH.FORGET_PASSWORD.NEW.ONE`)'>
                <FwInput
                    :value='password'
                    type='password'
                    name='password'
                    :placeholder='$t(`AUTH.LOGIN.FORM.PASSWORD.PLACEHOLDER`)'
                    inputStyle='gray'
                    :error='getFieldErrorTextByRule(password, PASSWORD, passwordRules)'
                    @update='value => password = value'
                    @input='clearServerErrorsBase(PASSWORD)'
                    @blur='addCurrentInputToValidateArray(PASSWORD)'>
                </FwInput>
            </FwFormInput>
            <FwFormInput
                class='h-mb-15'
                :fieldHasError='fieldHasErrorByRule(password_repeat, PASSWORD_REPEAT, passwordRules)'
                labelType='label-thin'
                :title='$t(`AUTH.FORGET_PASSWORD.NEW.TWO`)'>
                <FwInput
                    :value='password_repeat'
                    type='password'
                    name='password'
                    :placeholder='$t(`AUTH.LOGIN.FORM.PASSWORD.PLACEHOLDER`)'
                    inputStyle='gray'
                    :error='getFieldErrorTextByRule(password_repeat, PASSWORD_REPEAT, passwordRules)'
                    @update='value => password_repeat = value'
                    @input='clearServerErrorsBase(PASSWORD_REPEAT)'
                    @blur='addCurrentInputToValidateArray(PASSWORD_REPEAT)'>
                </FwInput>
            </FwFormInput>
        </form>
    </div>
    <div class='h-flex h-flex-center h-width-100p'>
        <FwButton
            class='h-mt-30'
            borderRadiusType='small-border'
            :disabled='!isFormValid'
            @click='sendDataToServer'>
            {{ $t('AUTH.RESET_PASSWORD.BUTTON') }}
        </FwButton>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Emit, mixins, Vue } from 'vue-facing-decorator';
import { useValidation } from '@/composables/useValidation';
import { PASSWORD, PASSWORD_REPEAT } from '@/helpers/auth';
// @ts-ignore-next-line
import { ResetPasswordPayloadType } from '@/types/Auth';

type ValidationTouchRecordsItemType = {
    field: string,
    value: boolean,
}

@Component
export default class ResetPasswordForm extends Vue {
    [PASSWORD]: string = '';
    [PASSWORD_REPEAT]: string = '';
    PASSWORD: string = PASSWORD;
    PASSWORD_REPEAT: string = PASSWORD_REPEAT;
    passwordRules: string[] = ['required', 'passwordMin'];

    validation = useValidation();

    get fieldHasErrorByRule() {
        return this.validation.fieldHasErrorByRule;
    }

    get getFieldErrorTextByRule() {
        return this.validation.getFieldErrorTextByRule;
    }

    get clearServerErrorsBase() {
        return this.validation.clearServerErrorsBase;
    }

    get addCurrentInputToValidateArray() {
        return this.validation.addCurrentInputToValidateArray;
    }

    get isFormValid() {
        return this.validation.passwordValidator({ value: this[PASSWORD] }) &&
            this.validation.validatePasswordMatch({ password: this[PASSWORD], passwordNew: this[PASSWORD_REPEAT] });
    }

    @Emit('submitForm')
    sendDataToServer(): ResetPasswordPayloadType {
        return {
            [PASSWORD]: this[PASSWORD],
            [PASSWORD_REPEAT]: this[PASSWORD_REPEAT],
        };
    }
}
</script>
